// extracted by mini-css-extract-plugin
export default {"hero":"Hero_hero__zvVCj","heroContent":"Hero_heroContent__3EKA5","name":"Hero_name__7q6QK","title":"Hero_title__rL9MQ","tagline":"Hero_tagline__-iBjv"};